import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import HomeIcon from '../icons/HomeIcon'
import WorkIcon from '../icons/WorkIcon'
import { SavedAddress } from '../../types/address'
import { AppDispatch, RootState } from 'store'
import { useParams } from 'react-router-dom'
import { fetchInfluencerAddressesThunk } from 'slices/addressBook/thunk'

interface AddressListProps {
    // onAddNew: () => void
    onSelection?: (savedAddress: SavedAddress) => void
}
const AddressList: React.FC<AddressListProps> = ({ onSelection }) => {

    const dispatch: AppDispatch = useDispatch();
    const {campaignId, collaborationId} = useParams();
    const collaboration = useSelector((state: RootState) => state.collaborations.items[campaignId!]?.[collaborationId!])
    const influencerId = collaboration?.influencer?.uuid;

    const addressData = useSelector((state: RootState) => state.addressBook.influencers[influencerId!]);
    const addressBook = addressData?.items ?? [];

    const [selectedAddress, setSelectedAddress] = useState<SavedAddress|null>(null);

    const fetchAddressBook = useCallback(() => {
        if(influencerId)
            dispatch(fetchInfluencerAddressesThunk({influencerId}));
    }, [dispatch, influencerId])

    useEffect(() => {
        fetchAddressBook();
    }, [dispatch, fetchAddressBook, influencerId])

    const handleClick = (address: SavedAddress) => {
        setSelectedAddress(address);
    }

    useEffect(() => {
        if(onSelection && selectedAddress) onSelection(selectedAddress)
    }, [selectedAddress])


    return (
        <div className="addresses overflow-scroll">
            {/* <div className="action-btns">
                <div className="address-action-btn" onClick={onAddNew}>
                    <AddCircle />
                    Add New Address
                </div>
            </div> */}
            <div className="location-list">
                <span className="location-list-title">Saved Address</span>
                {
                    addressBook.map((address, i) => {
                        return (
                            <div className="location-list-item cursor-pointer" key={i} onClick={() => handleClick(address)} >
                                <div className="location-list-item-top">
                                    <div className="gig-selection-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            className="form-check-input gig-selection-check-input radio-check"
                                            checked={selectedAddress?.uuid === address.uuid}
                                            onChange={() => setSelectedAddress(address)}
                                        />
                                    </div>
                                    {address.name === 'Home' ? <HomeIcon /> : (address.name === 'Work' ? <WorkIcon /> : "")}
                                    <span className="location-list-item-title">
                                        {address.name}
                                    </span>
                                </div>
                                <span className="location-list-item-address">
                                    {address.premise ? `${address.premise},` :''} {address.sublocality ? `${address.sublocality},` : ''} {address.city ? `${address.city},` : ''} {address.region ? `${address.region},` : ''} {address.pincode}
                                </span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default AddressList